import * as actions from './actions';
import * as userActions from '../user/actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    isData: false,
    categories: null,
    dateFrom: null,
    dateTo: null,
};

export const newsDigestsSuggestionsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.SET_NEWS_DIGESTS_SUGGESTION_DATA:
            return {
                isData: true,
                categories: action.data.categories,
                dateFrom: action.data.dateFrom,
                dateTo: action.data.dateTo,
            };

        case actions.CLEAN_NEWS_DIGESTS_SUGGESTION_DATA:
            return initialState;

        case userActions.LOGOUT:
            return initialState;

        case userActions.LOGIN:
            // console.log('+++LOGIN USER 30+++');
            return initialState;

        case CLEAN_PERSISTED_STORAGE:
            console.log('+++CLEAN PERSISTED STORAGE 34+++');
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/newsDigestsSuggestions/reducer.js